<i18n src="@/locales/models/producer.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/crop_field.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/organization/production/productivity_by_producer_exp/show_process.yml"
  lang="yaml"
></i18n>

<template>
  <div class="grid md:grid-cols-5 gap-4 w-full">
    <div v-for="(filter, key) in filters" :key="key" class="flex flex-col">
      <div class="sm:col-span-3">
        <label class="label-form">
          {{ filter.label }}
        </label>
        <div class="mt-1">
          <input
            v-if="filter.type === 'text'"
            :id="key"
            v-model="filterValues[key]"
            type="text"
            class="input-text"
          />
          <input
            v-if="filter.type === 'number'"
            :id="key"
            v-model.number="filterValues[key]"
            type="number"
            class="input-text"
          />
        </div>
      </div>
    </div>
    <div class="flex flex-col justify-end pb-1">
      <label class="label-form">
      </label>
      <div class="mt-1">
        <success-button  @click.prevent="applyFilters()" :label="$t('labels.apply_filters')" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductivityFilters",
  data() {
    return {
      filterValues: {
        organization_producer_code: "",
        producer_code: "",
        lastname: "",
        name: "",
      },
      filters: {
        organization_producer_code: { label: this.$t("model.producer.organization_producer.producer_code"), type: "text" },
        producer_code: { label: this.$t("model.producer.producer_code"), type: "text" },
        lastname: { label: this.$t("model.producer.lastname"), type: "text" },
        name: { label: this.$t("model.producer.name"), type: "text" },
      },
    };
  },
  methods: {
    applyFilters() {
      const cleanFilters = Object.fromEntries(
        Object.entries(this.filterValues).filter(([, value]) => value !== "" && value !== null)
      );
      this.$emit("apply-filters", cleanFilters);
    },
  },
};
</script>
